const isElement = (o) => (
  typeof HTMLElement === 'object' ? o instanceof HTMLElement // DOM2
    : o && typeof o === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string'
);

export default async (selector, onChoiceCallback, options = {}) => {
  const { default: Choices } = await import('choices.js');

  const element = isElement(selector) ? selector : document.querySelector(selector);
  let dynOptions = {};
  if (element?.hasAttribute('multiple')) dynOptions = { ...dynOptions, removeItemButton: true };

  const searchSelect = new Choices(selector, {
    itemSelectText: options.itemSelectText || '',
    allowHTML: options.allowHTML || false,
    ...dynOptions,
  });
  searchSelect.passedElement.element.addEventListener('choice', onChoiceCallback);
};
